import { preview } from '@/components/form/preview'
import { Props } from './typings'
import { Header } from './components/Header'

export function BulkView(props: Props) {
  const { simulations } = props

  return <preview.Root applyPendingFitMapOnMount header={<Header simulations={simulations} />} />
}
